import {z as zod} from "zod";

export type OttopilotTargetsWorkspaceCapabilityConfiguration = Record<string, never>;

export const ottopilotTargetsWorkspaceCapabilityConfigurationValidator: zod.ZodType<OttopilotTargetsWorkspaceCapabilityConfiguration> = zod.strictObject({});
